
export interface BudgetSepaInfoInterface {
    id?: string;
    address?: string;
    postalCode?: string;
    town?: string;
    state?: string;
}

export class BudgetSepaInfo implements BudgetSepaInfoInterface {
    public id?: string;
    public address?: string;
    public postalCode?: string;
    public town?: string;
    public state?: string;
}
